import { render } from "./UnassignedPackagesEditing.vue?vue&type=template&id=062a1809&ts=true"
import script from "./UnassignedPackagesEditing.vue?vue&type=script&lang=ts"
export * from "./UnassignedPackagesEditing.vue?vue&type=script&lang=ts"

import "./UnassignedPackagesEditing.vue?vue&type=style&index=0&id=062a1809&lang=scss"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__